<template>
	<div>	
		<div v-if="project_type != 'archived' && buyerProject">
			<v-card>
				<v-hover>
					<template v-slot:default="{ hover }">
						<v-card-title class="py-0 mb-4" :class="`elevation-${hover ? 12 : 0}`">

							<div @click="showOverview(buyerProject)" class="d-block flex-grow-1 py-3" style="cursor: pointer">
								<div class="d-flex d-block align-center justify-space-between">
									<div class="d-inline d-flex align-center">
										<customIcon :name="buyerProject.modinfo.module_key" class="d-inline mr-2 lend--text icon-size-header" />
										<div class="d-inline sansation project_title lend--text">
											<div class="d-inline">{{ buyerProject.modinfo.module_name }}{{ buyerProject.project_title ? ' :: '+buyerProject.project_title : '' }}</div>
										</div>
									</div>

									<div class="d-flex d-inline text-right sansation project_title">
										<div v-if="buyerProject.secondary_access" class="d-inline mr-3"><v-icon color="general_grey lighten-2" class="mt-n1">mdi-account-multiple-plus</v-icon></div>
										<div class="d-inline mr-3 general_grey--text">Profile Status:</div>
										<div class="d-inline primary--text text--darken-1">
											<div v-if="buyerProject.questionnaire_progress">{{ buyerProject.profile_percentage }}% ({{ buyerProject.questionnaire_progress.finished }} of {{ buyerProject.questionnaire_progress.total }}) sections</div>
											<div v-else>sectional progress not calculated yet</div>
										</div>
									</div>
								</div>
								
								<v-progress-linear
									:active="true"
									buffer-value="100"
									height="4"
									striped
									class="d-block mb-1"
									:value="buyerProject.profile_percentage"
									:color="buyerProject.profile_percentage == 100 ? `primary` : `secondary`">
								</v-progress-linear>

								<div class="d-flex d-block sansation project_subtitle justify-space-between align-center">
									<div class="d-flex d-inline justify-start">&nbsp;</div>
									<div class="d-flex d-inline general_grey--text justify-end">
										<div class="d-inline mr-3 general_grey--text">Eligible to Express Interest:</div>
										<div class="d-inline primary--text text--darken-1">
											{{ buyerProject.status == 'completed' ? 'Yes' : 'No' }}
										</div>
									</div>
								</div>
							</div>
						</v-card-title>
					</template>
				</v-hover>
			</v-card>
			
			<div class="my-4">&nbsp;</div>
		</div>
		
		<v-card
			v-for="prj of projects" 
			:key="prj.project_id">
			
			<v-hover v-if="!prj.modinfo.is_submodule">
				<template v-slot:default="{ hover }">
					<v-card-title class="py-0 mb-4" :class="hover ? `elevation-6` : ``">

						<div @click="showOverview(prj)" class="d-block flex-grow-1 py-3" style="cursor: pointer">
							<div class="d-flex align-center justify-space-between">
								<div class="d-flex align-center">
									<customIcon :name="prj.modinfo.module_key" class="d-inline align-start ml-n2 mr-1 lend--text icon-size-header" />
									<div class="d-inline sansation project_title lend--text">
										<span>{{ prj.modinfo.module_name }}</span><span v-html="prj.project_title ? prj.project_title.length >= 56 ? ` :: ${prj.project_title.substr(0, 53)}<br>${prj.project_title.substr(54, prj.project_title.length)}` : ' :: '+prj.project_title : ''"></span>
									</div>
								</div>

								<div class="d-flex align-start text-right sansation project_title">
									<div v-if="prj.secondary_access" class="d-inline mr-3"><v-icon color="general_grey lighten-2" class="mt-n1">mdi-account-multiple-plus</v-icon></div>
									<div class="d-inline error--text text--darken-3 mr-1" v-if="prj.expedite">Expedited ::</div>
									<div class="d-inline mr-3 general_grey--text">Status:</div>
									<div class="d-inline" :class="prj.status_color">
										{{ prj.status_text }}
									</div>
								</div>
							</div>
							
							<v-progress-linear
								:active="true"
								buffer-value=100
								height=4
								striped
								class="d-block mb-1"
								:value="prj.complete"
								:color="prj.status_progress_color">
							</v-progress-linear>

							<div class="d-flex d-block sansation project_subtitle justify-space-between align-center">
								<div class="d-flex d-inline justify-start">
									<div v-if="prj.modinfo.module_key != 'entity-maintenance-program'">
										<div class="d-inline mr-3 general_grey--text">Current Step:</div>
										<div class="d-inline primary--text text--darken-1">
											<span v-if="prj.stage_name_text == 'How Did We Do?'">
												{{ prj.stage_name_text }} <v-icon color="warning" class="mt-n1 ml-3">mdi-star-face</v-icon> (survey takes less than a minute)
											</span>
											<span v-else>
												{{ prj.stage_name_text }}
											</span>
										</div>
									</div>
								</div>

								<div class="d-flex d-inline justify-end">
									<div class="general_grey--text d-inline">{{ prj.status == 'complete' ? 'Completion Date:' : 'Est. Completion Date:' }}</div>
									<div class="ml-3 primary--text text--darken-1 d-inline">{{ formatDate(prj.close_date, 'mmmm d, yyyy') }}</div>
								</div>

							</div>
						</div>

					</v-card-title>
				</template>
			</v-hover>

		</v-card>

		<v-card class="py-0 mt-8 mb-10">
			<ModuleTeamInfo 
				:moduleInfo="{}"
				orientation="horizontal"
				:readyToLoadTeam="true" />
		</v-card>
	</div>
</template>

<script>
	import dateFormat, { masks } from "dateformat";

	import ModuleTeamInfo from './ModuleTeamInfo';
	
	export default {
    	name: 'DashProjects',
		
		components: {
            ModuleTeamInfo
		},

		props: {
			projects: Array,
			buyerProject: Object,
			project_type: String,
			authUser: Object
		},

		methods: {
			formatDate: function ( date, mask ) {
				if ( date == null ) return `N/A`
				return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            },

			showOverview: async function ( prj ) {
				// console.log(prj)
				const secondary_user = prj.users.length ? prj.users.find( usr => usr.user_id == this.authUser.id ) : false
				// console.log(secondary_user)
				// if ( prj.user_id == this.authUser.id || ( secondary_user && (secondary_user.read || secondary_user.write || secondary_user.deliverables) )) {
					this.$router.push( { path: prj.overview_route+'/'+prj.project_id } );
				// }
			}
		},

		mounted() {
			// console.log(this.projects)
		}
  }
</script>

<style scoped>
	.icon-size-header {
        min-width: 2.5rem;
        max-width: 2.5rem;
	}
	.project_title {
		font-size: 1.12rem !important;
	}
	.project_subtitle {
		font-size: 1rem !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/DashProjects.vue